import React, { useEffect, useState } from "react";
import styles from "../../assets/scss/Billing/Billingtable.module.scss";
import Pagination from "../../Components/Common/Pagination";
import {  FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useGetMyBillsQuery } from "../../slices/admin/admin";
import FarmerMyBilling from "./FarmerMyBilling";
import { getUserInfo } from "../../utils/user.util";
import { capitalize } from "../../utils/capitalize";

const MyBilling = ({ onStatsUpdate }) => {
    const [search, setSearch] = useState("");
    const [paymentStatus, setPaymentStatus] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const navigate = useNavigate();


    const user = getUserInfo();
    //console.log(user, "getUserInfo6789");

    const offset = currentPage;

    const { data, isLoading } = useGetMyBillsQuery({
        search,
        paymentStatus,
        paymentMethod,
        fromDate: fromDate ? fromDate.toISOString().split("T")[0] : "",
        toDate: toDate ? toDate.toISOString().split("T")[0] : "",
        offset,
        limit,
    });

    const bills = data?.data || [];
    const totalPages = Math.ceil((data?.total || 0) / limit);



    useEffect(() => {
        if (user?.type !== "farmer" && data && onStatsUpdate) {
            onStatsUpdate({
                totalBills: data.total || 0,
                collected: data.totalPaidBills || 0,
                remaining: data.totalAmountPending || 0,
            });
        }
    }, [user?.type, data, onStatsUpdate]);

    // return (
    //     <div>
    //         <div className={styles.filterBar}>
    //             <input
    //                 type="text"
    //                 placeholder="Search by Receipt..."
    //                 className={styles.searchInput}
    //                 value={search}
    //                 onChange={(e) => setSearch(e.target.value)}
    //             />

    //             <select
    //                 className={styles.inputs}
    //                 value={paymentMethod}
    //                 onChange={(e) => setPaymentMethod(e.target.value)}
    //             >
    //                 <option value="">Payment Method</option>
    //                 <option value="cash">Cash</option>
    //                 <option value="upi">UPI</option>
    //                 <option value="bank">Bank</option>
    //             </select>

    //             <select
    //                 className={styles.inputs}
    //                 value={paymentStatus}
    //                 onChange={(e) => setPaymentStatus(e.target.value)}
    //             >
    //                 <option value="">Select Status</option>
    //                 <option value="paid">Paid</option>
    //                 <option value="pending">Unpaid</option>
    //             </select>

    //             <DatePicker
    //                 selected={fromDate}
    //                 onChange={(date) => setFromDate(date)}
    //                 dateFormat="dd.MM.yyyy"
    //                 placeholderText="From Date"
    //                 maxDate={new Date()}
    //                 isClearable
    //                 className={styles.inputss}
    //             />

    //             <DatePicker
    //                 selected={toDate}
    //                 onChange={(date) => setToDate(date)}
    //                 dateFormat="dd.MM.yyyy"
    //                 placeholderText="To Date"
    //                 maxDate={new Date()}
    //                 isClearable
    //                 className={styles.inputss}
    //             />

    //             <button
    //                 className={styles.clearBtn}
    //                 onClick={() => {
    //                     setSearch("");
    //                     setPaymentStatus("");
    //                     setPaymentMethod("");
    //                     setFromDate(null);
    //                     setToDate(null);
    //                     setCurrentPage(1);
    //                 }}
    //             >
    //                 Clear All
    //             </button>
    //         </div>

    //         <div className={styles.tableWrapper}>
    //             <table>
    //                 <thead>
    //                     <tr>
    //                         <th>Receipt ID</th>
    //                         <th>Store Name</th>
    //                         <th>Created Date</th>
    //                         <th>Amount</th>
    //                         <th>Payment Method</th>
    //                         <th>Status</th>
    //                         <th>Actions</th>
    //                     </tr>
    //                 </thead>
    //                 <tbody>
    //                     {isLoading ? (
    //                         <tr>
    //                             <td colSpan="7">Loading...</td>
    //                         </tr>
    //                     ) : bills.length === 0 ? (
    //                         <tr>
    //                             <td className={styles.noData} colSpan="7">No bills found</td>
    //                         </tr>
    //                     ) : (
    //                         bills.map((item, idx) => (
    //                             <tr key={idx}>
    //                                 <td>{item.receiptNo}</td>
    //                                 <td>{item?.storeId?.storeName || "--"}</td>
    //                                 <td>{new Date(item.createdAt).toLocaleDateString()}</td>
    //                                 <td>₹{item.totalAmount}</td>
    //                                 <td>{item.paymentMethod || "—"}</td>
    //                                 <td>
    //                                     <span
    //                                         className={`${styles.status} ${item.paymentStatus === "paid"
    //                                             ? styles.paid
    //                                             : styles.unpaid
    //                                             }`}
    //                                     >
    //                                         {item.paymentStatus}
    //                                     </span>
    //                                 </td>
    //                                 <td>
    //                                     <div className={styles.actions}>

    //                                         <FaEye
    //                                             className={styles.icon}
    //                                             onClick={() => navigate(`/dashboard/MyBilling?id=${item._id}&mode=view`)}
    //                                         />

    //                                     </div>
    //                                 </td>
    //                             </tr>
    //                         ))
    //                     )}
    //                 </tbody>
    //             </table>
    //         </div>

    //         {/* --- Pagination --- */}
    //         <div className={styles.paginationWrapper}>
    //             <Pagination
    //                 currentPage={currentPage}
    //                 totalPages={totalPages}
    //                 onPageChange={setCurrentPage}
    //             />
    //             <select
    //                 className={styles.inputsbtn}
    //                 value={limit}
    //                 onChange={(e) => {
    //                     setLimit(Number(e.target.value));
    //                     setCurrentPage(1);
    //                 }}
    //             >
    //                 <option value={10}>10 rows</option>
    //                 <option value={25}>25 rows</option>
    //                 <option value={50}>50 rows</option>
    //             </select>
    //         </div>
    //         <FarmerMyBilling />
    //     </div>
    // );
    return (
        <div>
            {user?.type === "farmer" ? (

                <FarmerMyBilling onStatsUpdate={onStatsUpdate} />
            ) : (
                <>
                    {/* --- Filters --- */}
                    <div className={styles.filterBar}>
                        <input
                            type="text"
                            placeholder="Search by Receipt..."
                            className={styles.searchInput}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />

                        <select
                            className={styles.inputs}
                            value={paymentMethod}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                        >
                            <option value="">Payment Method</option>
                            <option value="cash">Cash</option>
                            <option value="upi">UPI</option>
                            <option value="bank">Bank</option>
                        </select>

                        <select
                            className={styles.inputs}
                            value={paymentStatus}
                            onChange={(e) => setPaymentStatus(e.target.value)}
                        >
                            <option value="">Select Status</option>
                            <option value="paid">Paid</option>
                            <option value="pending">Unpaid</option>
                        </select>

                        <DatePicker
                            selected={fromDate}
                            onChange={(date) => setFromDate(date)}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="From Date"
                            maxDate={new Date()}
                            isClearable
                            className={styles.inputss}
                        />

                        <DatePicker
                            selected={toDate}
                            onChange={(date) => setToDate(date)}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="To Date"
                            maxDate={new Date()}
                            isClearable
                            className={styles.inputss}
                        />

                        <button
                            className={styles.clearBtn}
                            onClick={() => {
                                setSearch("");
                                setPaymentStatus("");
                                setPaymentMethod("");
                                setFromDate(null);
                                setToDate(null);
                                setCurrentPage(1);
                            }}
                        >
                            Clear All
                        </button>
                    </div>

                    {/* --- Table --- */}
                    <div className={styles.tableWrapper}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Receipt ID</th>
                                    <th>Store Name</th>
                                    <th>Created Date</th>
                                    <th>Amount</th>
                                    <th>Payment Method</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan="7">Loading...</td>
                                    </tr>
                                ) : bills.length === 0 ? (
                                    <tr>
                                        <td className={styles.noData} colSpan="7">
                                            No bills found
                                        </td>
                                    </tr>
                                ) : (
                                    bills.map((item, idx) => (
                                        <tr key={idx}>
                                            <td className="notranslate">{item.receiptNo}</td>
                                            <td>{item?.storeId?.storeName ? capitalize(item.storeId.storeName) : "--"}</td>
                                            <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                                            <td>₹{item.totalAmount}</td>
                                            <td>{item.paymentMethod ? capitalize(item.paymentMethod) : "—"}</td>
                                            <td>
                                                <span
                                                    className={`${styles.status} ${item.paymentStatus === "paid"
                                                        ? styles.paid
                                                        : styles.unpaid
                                                        }`}
                                                >
                                                    {item.paymentStatus}
                                                </span>
                                            </td>
                                            <td>
                                                <div className={styles.actions}>
                                                    <FaEye
                                                        className={styles.icon}
                                                        onClick={() =>
                                                            navigate(
                                                                `/dashboard/MyBilling?id=${item._id}&mode=view`
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                     <div className={styles.amountdiv}>
                            <p >Total sales received amount: {data?.totalPaidAmount}</p>
                            <p>Total sales pending amount: {data?.totalNotPaidAmount}</p>
                          </div>

                    {/* --- Pagination --- */}
                    <div className={styles.paginationWrapper}>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                        />
                        <select
                            className={styles.inputsbtn}
                            value={limit}
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={10}>10 rows</option>
                            <option value={25}>25 rows</option>
                            <option value={50}>50 rows</option>
                        </select>
                    </div>
                </>
            )}
        </div>
    );

};

export default MyBilling;
